import React, { useState } from "react";
import { Collapse, Button, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import styles from "./AccountMenu.module.scss";
import WandaLogo from "../../assets/images/WandaLogoFull.svg";
import dashboardIcon from "../../assets/images/dashboardIcon.svg";
import myAccountIcon from "../../assets/images/myAccountIcon.svg";
import helpInfoIcon from "../../assets/images/helpInfoIcon.svg";
import legalInfoIcon from "../../assets/images/legalInfoIcon.svg";
import closeIconGrey from "../../assets/images/closeIconGrey.svg";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";
import WandaContactUsModal from "./WandaContactUsModal";
import { downArrow } from "../../assets/images";

type Props = {
  panelActiveKey: string[];
  setPanelActiveKey: Function;
  handleDrawerClose: Function;
};

function AccountMenu(props: Props) {
  const { panelActiveKey, setPanelActiveKey, handleDrawerClose } = props;
  const { Panel } = Collapse;
  const history = useHistory();
  const { caregiverSummaryInfo } = usePersonSummaryCtx();
  const [isContactUsModalVisible, setIsContactUsModalVisible] = useState<
    boolean
  >(false);

  const faqUrl: string = "https://wanda.care/faq/";
  const termsofUseUrl: string = "https://wanda.care/terms-of-use/";
  const privacyPolicyUrl: string = "https://wanda.care/terms/privacy-policy/";
  const termsOfSaleUrl: string = "https://wanda.care/terms/termsofsale/";

  const handlePanelChange = (keys: string | string[]) => {
    setPanelActiveKey(keys);
  };

  const handleDashboardMenuClick = () => {
    handleDrawerClose();
    history.push("/DashBoard");
  };

  const handleMyAccountMenuClick = () => {
    handleDrawerClose();
    history.push(`/DashBoard/EditProfile/${caregiverSummaryInfo.personId}`);
  };

  const handleContactUsMenuClick = () => {
    handleDrawerClose();
    setIsContactUsModalVisible(true);
  };

  return (
    <>
      <div className={styles.accountMenuHeader}>
        <img
          className={styles.drawerWandaLogo}
          src={WandaLogo}
          alt="WandaLogo"
        />
        <img
          src={closeIconGrey}
          alt="closeIconGrey"
          onClick={() => handleDrawerClose()}
        />
      </div>
      <div>
        <Button id={styles.accountItems} onClick={handleDashboardMenuClick}>
          <img src={dashboardIcon} alt="dashboardIcon" />
          <span>Dashboard</span>
        </Button>
        <Button id={styles.accountItems} onClick={handleMyAccountMenuClick}>
          <img src={myAccountIcon} alt="myAccountIcon" />
          <span>My account</span>
        </Button>
        <Collapse
          className={styles.accountInfoPanel}
          expandIconPosition="right"
          activeKey={panelActiveKey}
          onChange={handlePanelChange}
          bordered={false}
          ghost
          expandIcon={({ isActive }) => (
            <img
              src={downArrow}
              alt="downArrow"
              id={isActive ? styles.rotateIcon : styles.originalIconPosition}
            />
          )}
        >
          <Panel
            header={
              <div id={styles.accountItems}>
                <img src={helpInfoIcon} alt="helpInfoIcon" />
                <span>Help</span>
              </div>
            }
            key="1"
          >
            <Button id={styles.accountItems} onClick={handleContactUsMenuClick}>
              <span className={styles.contactUsBtn}>Contact us</span>
            </Button>
            <a
              id={styles.accountInfoItems}
              href={faqUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleDrawerClose()}
            >
              <Row className={styles.accountInfoItemsMargin}>
                <Col span={3} />
                <Col span={21}>FAQ</Col>
              </Row>
            </a>
          </Panel>
          <Panel
            header={
              <div id={styles.accountItems}>
                <img src={legalInfoIcon} alt="legalInfoIcon" />
                <span>Legal</span>
              </div>
            }
            key="2"
          >
            <a
              id={styles.accountInfoItems}
              href={termsofUseUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleDrawerClose()}
            >
              <Row className={styles.accountInfoItemsMargin}>
                <Col span={3} />
                <Col span={21}>Terms of Use</Col>
              </Row>
            </a>
            <a
              id={styles.accountInfoItems}
              href={privacyPolicyUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleDrawerClose()}
            >
              <Row className={styles.accountInfoItemsMargin}>
                <Col span={3} />
                <Col span={21}>Privacy policy</Col>
              </Row>
            </a>
            <a
              id={styles.accountInfoItems}
              href={termsOfSaleUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleDrawerClose()}
            >
              <Row className={styles.accountInfoItemsMargin}>
                <Col span={3} />
                <Col span={21}>Terms of sale</Col>
              </Row>
            </a>
          </Panel>
        </Collapse>
      </div>
      <WandaContactUsModal
        isContactUsModalVisible={isContactUsModalVisible}
        setIsContactUsModalVisible={setIsContactUsModalVisible}
      />
    </>
  );
}
export default AccountMenu;
